import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem } from '../utils/helpers/style.js';
import { lineHeights } from '../constants/line-heights.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var radioAttributesNative = {
  color: 'primary',
  inactive: 'widget.inactive',
  readOnly: 'label.disabled',
  disabled: 'label.disabled',
  fontColor: 'text',
  fontSize: '18px',
  buttonOrientation: 'left'
};
var radioThemeNative = _objectSpread(_objectSpread({}, radioAttributesNative), {}, {
  variants: {
    condensed: {
      fontSize: '16px'
    }
  }
});
var radioAttributesWeb = {
  color: 'primary',
  background: 'widget.control',
  label: {
    disabled: 'label.disabled',
    normal: 'text',
    fontSize: px2rem(18),
    lineHeight: lineHeights.tight
  },
  disabled: {
    borderColor: 'border.disabled',
    backgroundColor: 'widget.disabled'
  },
  unselected: {
    color: 'widget.inactive'
  }
};
var radioThemeWeb = _objectSpread(_objectSpread({}, radioAttributesWeb), {}, {
  variants: {
    condensed: {
      label: {
        fontSize: px2rem(16),
        lineHeight: lineHeights.normal
      }
    }
  }
});

export { radioThemeNative, radioThemeWeb };
